import {
  ACCREDITATION_STATUSES_FAILURE,
  ACCREDITATION_STATUSES_REQUEST,
  ACCREDITATION_STATUSES_SUCCESS,
} from '../actions/accreditation_statuses'

export const accreditationStatuses = (
  state = {
    isFetching: false,
    results: [],
    errorMessage: null,
    count: 0,
    nextUrl: null,
    requestUrl: '',
  },
  action
) => {
  switch (action.type) {
    case ACCREDITATION_STATUSES_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }
    case ACCREDITATION_STATUSES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        results: action.response.results,
        count: action.response.count,
        nextUrl: action.response.next,
        errorMessage: null,
        requestUrl: action.requestUrl,
      }
    case ACCREDITATION_STATUSES_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.error,
        requestUrl: action.requestUrl,
      }
    default:
      return state
  }
}
